import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NotificationToModifyOtherTask, OtherTaskNotificationModel } from '@evorait/pace-core';

@Component({
    selector: 'pace-other-task-list',
    templateUrl: './other-tasks-list.component.html',
    styleUrls: ['./other-tasks-list.component.scss'],
})
export class OtherTasksListComponent implements OnInit {
    @Input({ required: true })
    public tasks: OtherTaskNotificationModel[];
    @Input()
    public isCustomerTab = false;
    @Input()
    public isLoading = true;

    @Output()
    public getTask = new EventEmitter<NotificationToModifyOtherTask>();

    public firstColumnLabel = 'equidescr';
    public orderBy = '';
    public reverse = false;

    public ngOnInit(): void {
        this.firstColumnLabel = this.isCustomerTab ? 'equidescr' : 'notificationNo';
    }

    public getTaskClickHandler(task: OtherTaskNotificationModel): void {
        const taskData: NotificationToModifyOtherTask = {
            FrontId: task.frontId,
            NotificationNo: task.notificationNo,
            TaskNo: task.taskNo,
            TaskCodeGrp: task.taskCodeGrp,
            TaskCode: task.taskCode,
            TaskStatus: task.taskStatus,
            PlannedDate: task.notifStartDate,
            PlannedEndDate: task.notifEndDate,
            Deadline: task.deadline,
            PlannedStartTime: task.notifStartTime,
            PlannedEndTime: task.notifEndTime,
            EstimatedDuration: task.duration,
            Equidescr: task.equidescr,
            ShortText: task.shortText,
            Equipment: task.equipment,
        };
        this.getTask.emit(taskData);
    }

    public setOrderBy(field: string): void {
        if (this.orderBy === field) {
            this.reverse = !this.reverse;
        } else {
            this.orderBy = field;
        }
    }
}
